<template>
    <div>
        <v-row class="bradcrumb">
            <router-link :to="{name: 'role-links' }" class="root">
                Dashboard
            </router-link>
            /
            <router-link :to="{name: 'admin-import' }" class="root">
                Admin Import
            </router-link>
            <span class="child">/ Import Exam Time Table </span>
        </v-row>
        <br />
        <v-card class="card">
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-card-title class="heading">Import Exam Time Table</v-card-title>
            <v-card class="box">
                <div class="flex">
                    <div></div>
                    <div>
                        <a href="https://easypariksha.s3.ap-south-1.amazonaws.com/import_excel_csv_file/import_exam-time_table.csv">
                            <v-btn :loading="loading3" :disabled="loading3" color="success" class="ma-2 white--text downbtn" @click="loader = 'loading3'">
                                <v-icon left dark>mdi-cloud-download</v-icon>
                                Download import CSV format
                            </v-btn>
                        </a>
                    </div>
                </div>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" lg="4" sm="12">
                            <v-file-input dense v-model="file" accept=".csv" :hint="file != null? '':'Please Select File'" persistent-hint color="rgb(1, 127, 152)" label="Choose File" prepend-icon="mdi-paperclip" outlined :show-size="1000">
                            </v-file-input>
                        </v-col>
                        <v-col cols="4"> </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="4">
                            <center>
                                <v-btn @click="submitFile" :loading="output_load" class="button">
                                    Upload
                                    <v-icon right>mdi-cloud-upload</v-icon>
                                </v-btn>
                            </center>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-card class="box">
              
                <div >
                    <v-form ref="form">
						<div >
							<v-row>
								<v-col xs="12" sm="12" lg="4" md="6" cols="12">
									<label class="bold">Academic Year</label>
									<v-autocomplete
										:items="ay_list"
										item-value="id"
										item-text="ay"
										v-model="selected_ay"
										:rules="[v => !!v || 'required']"
										outlined
										dense
										placeholder="Select Academic Year"
										class="select"
									></v-autocomplete>
								</v-col>
								<v-col xs="12" sm="12" lg="4" md="6" cols="12">
									<label class="bold">Semester </label>
									<v-autocomplete
										:items="sem_list"
										item-value="id"
										item-text="sem"
										outlined
										dense
										placeholder="Select Semester"
										v-model="selected_sem"
										:rules="[v => !!v || 'required']"
                                        @change="findexam()"
										class="select"
									></v-autocomplete>
								</v-col>
								<v-col xs="12" sm="12" lg="4" md="6" cols="12">
									<label class="bold">Exam</label>
									<v-autocomplete
										:items="exam_list"
										item-value="id"
										item-text="exam"
										placeholder="Select Exam"
										outlined
										dense
										:rules="[v => !!v || 'required']"
										class="select"
										v-model="selected_exam"
									></v-autocomplete>
								</v-col>
							</v-row>
							<v-card-actions
								v-if="
									selected_ay && selected_sem && selected_exam 
								"
								class="justify-center"
							>
								<v-btn @click="findexamtimetable" class="mb-2 button btn" 
									>Fetch</v-btn
								>
							</v-card-actions>
						</div>
					</v-form>
                </div>
               
            </v-card>
            <!-- <v-row>
                <v-col cols="4">
                    <v-file-input dense v-model="file" accept=".csv" :hint="file != null? '':'Please Select File'" persistent-hint color="rgb(1, 127, 152)" label="Choose File" prepend-icon="mdi-paperclip" outlined :show-size="1000"> </v-file-input>
                </v-col>
                <v-col cols="4">
                </v-col>
                <v-col cols="4">
                    <a href="https://easypariksha.s3.ap-south-1.amazonaws.com/import_excel_csv_file/import_exam-time_table.csv">
                        <v-btn :loading="loading3" :disabled="loading3" color="success" class="ma-2 white--text downbtn " @click="loader = 'loading3'">
                            <v-icon left dark>mdi-cloud-download</v-icon>
                            Download import CSV format
                        </v-btn>
                    </a>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="4">
                    <center>
                        <v-btn @click="submitFile" :loading="output_load" class="button">
                            Upload
                            <v-icon right>mdi-cloud-upload</v-icon>
                        </v-btn>
                    </center>
                </v-col>
            </v-row> -->
            <template v-if="load==true">
                <v-data-table :headers="headers" :items="examtimetable_list" sort-by="ptype" class="elevation-1 nowrap" :search="search">
                    <template v-slot:top>
                        <v-toolbar flat color="white">
                             <download-excel class="mar" :data="examtimetable_list" :fields="export_table_headers" worksheet="examtimetable_list" name="ExamTimeTable.xls">
                                <v-btn color="success" dark class="mb-2">
                                    Export<v-icon dark>mdi-file-excel</v-icon>
                                </v-btn>
                            </download-excel>
                            <v-spacer></v-spacer>
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                            <span style="width: 20px;"></span>
                            <v-dialog v-model="dialog" max-width="500px">
                                <template v-slot:activator="{ on }">
                                    <v-btn class="button" v-on="on"> <v-icon left dark>mdi-account-plus</v-icon>Add New Exam Time Table </v-btn>
                                </template>
                                <v-card>
                                    <v-card-title class="heading">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                    <v-autocomplete
                                                        :items="examlist"
                                                        v-model="editedItem.ett_exam"
                                                        label="Select Exam "
                                                        :rules="[v => !!v || 'required']"
                                                        :hint="editedItem.ett_exam != ''? '':'Please Select Exam'"
                                                        persistent-hint
                                                    ></v-autocomplete>
                                                </v-col>

                                                <v-col cols="12" v-if="editedIndex != -1">
                                                    Exam
                                                    <v-autocomplete
                                                        dense
                                                        v-model="editedItem.ett_exam"
                                                        :items="examlist"
                                                        item-value="id"
                                                        persistent-hint
                                                        :error="errorMsg.ett_exam?true:false"
                                                        :error-messages="errorMsg.ett_exam?'Required':''"
                                                    ></v-autocomplete>
                                                </v-col>
                                                <br />
                                                <v-col cols="12" sm="12" md="12"> Select Exam Date :- <datetime format="DD-MM-YYYY" width="300px" v-model="editedItem.ett_examdate"></datetime> </v-col>
                                                <br />
                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                    <v-autocomplete
                                                        :items="exam_slot_list"
                                                        v-model="editedItem.ett_examslot"
                                                        label="Select Exam Slot "
                                                        :rules="[v => !!v || 'required']"
                                                        :hint="editedItem.ett_examslot != ''? '':'Please Select Exam Slot'"
                                                        persistent-hint
                                                    ></v-autocomplete>
                                                </v-col>

                                                <v-col cols="12" v-if="editedIndex != -1">
                                                    Exam Slot
                                                    <v-autocomplete
                                                        dense
                                                        v-model="editedItem.ett_examslot"
                                                        :items="exam_slot_list"
                                                        item-value="id"
                                                        persistent-hint
                                                        :error="errorMsg.ett_examslot?true:false"
                                                        :error-messages="errorMsg.ett_examslot?'Required':''"
                                                    ></v-autocomplete>
                                                </v-col>
                                                <br />
                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                    <v-autocomplete
                                                        :items="exam_course_list"
                                                        v-model="editedItem.ett_course"
                                                        item-text="name" item-value="id"
                                                        multiple
                                                        label="Select Course "
                                                        :rules="[v => !!v || 'required']"
                                                        :hint="editedItem.ett_course != ''? '':'Please Select Course'"
                                                        persistent-hint
                                                    ></v-autocomplete>
                                                </v-col>

                                                <v-col cols="12" v-if="editedIndex != -1">
                                                    Course
                                                    <v-autocomplete
                                                        dense
                                                        v-model="editedItem.ett_course_id"
                                                        :items="exam_course_list"
                                                        item-text="name"
                                                        item-value="id"
                                                        persistent-hint
                                                        :error="errorMsg.ett_course?true:false"
                                                        :error-messages="errorMsg.ett_course?'Required':''"
                                                    ></v-autocomplete>
                                                </v-col>

                                                <!-- <v-col cols="12" sm="12" md="12" v-if='editedIndex == -1'>
                                                <v-autocomplete :items="exam_program_type_list" v-model="editedItem.ett_programtype" label="Select Prgramm Type" :rules="[v => !!v || 'required']" :hint="editedItem.ett_programtype != ''? '':'Please Select Program Type'" persistent-hint></v-autocomplete>
                                            </v-col> -->

                                                <v-col cols="12" v-if="editedIndex != -1">
                                                    Program Type
                                                    <v-autocomplete
                                                        dense
                                                        v-model="editedItem.ett_programtype"
                                                        :items="exam_program_type_list"
                                                        item-value="id"
                                                        persistent-hint
                                                        :error="errorMsg.ett_programtype?true:false"
                                                        :error-messages="errorMsg.ett_programtype?'Required':''"
                                                    ></v-autocomplete>
                                                </v-col>

                                                <!-- <v-col cols="12" sm="12" md="12" v-if='editedIndex == -1'>
                                                <v-autocomplete :items="exam_program_list" v-model="editedItem.ett_program" label="Select Program " :rules="[v => !!v || 'required']" :hint="editedItem.ett_program != ''? '':'Please Select Program'" persistent-hint></v-autocomplete>
                                            </v-col> -->

                                                <v-col cols="12" v-if="editedIndex != -1">
                                                    Program
                                                    <v-autocomplete
                                                        dense
                                                        v-model="editedItem.ett_program"
                                                        :items="exam_program_list"
                                                        item-value="id"
                                                        persistent-hint
                                                        :error="errorMsg.ett_program?true:false"
                                                        :error-messages="errorMsg.ett_program?'Required':''"
                                                    ></v-autocomplete>
                                                </v-col>

                                                <!-- <v-col cols="12" sm="12" md="12" v-if='editedIndex == -1'>
                                                <v-autocomplete :items="exam_year_list" v-model="editedItem.ett_year" label="Select year " :rules="[v => !!v || 'required']" :hint="editedItem.ett_year != ''? '':'Please Select Year'" persistent-hint></v-autocomplete>
                                            </v-col> -->

                                                <v-col cols="12" v-if="editedIndex != -1">
                                                    Year
                                                    <v-autocomplete
                                                        dense
                                                        v-model="editedItem.ett_year"
                                                        :items="exam_year_list"
                                                        item-value="id"
                                                        persistent-hint
                                                        :error="errorMsg.ett_year?true:false"
                                                        :error-messages="errorMsg.ett_year?'Required':''"
                                                    ></v-autocomplete>
                                                </v-col>

                                                <!-- <v-col cols="12" sm="12" md="12" v-if='editedIndex == -1'>
                                                    <v-autocomplete :items="exam_status_list" v-model="editedItem.ett_examstatus" label="Select Exam Status " :rules="[v => !!v || 'required']"></v-autocomplete>
                                                </v-col>

                                                <v-col cols="12" v-if='editedIndex != -1'>Exam Status
                                                    <v-select dense v-model="editedItem.ett_examstatus" :items="exam_status_list" item-value="id" persistent-hint :error="errorMsg.ett_examstatus?true:false" :error-messages="errorMsg.ett_examstatus?'Required':''"></v-select>
                                                </v-col> -->

                                                <!--   <v-col cols="12" sm="12" md="12" v-if='editedIndex == -1'>
                                                <v-autocomplete :items="exam_template_name_list"  v-model="editedItem.ett_templatename" label="Select Template Name " :rules="[v => !!v || 'required']"></v-autocomplete>
                                            </v-col>

                                             <v-col cols="12" v-if='editedIndex != -1'>Template Name 
                                                <v-select dense v-model="editedItem.ett_templatename" :items="exam_template_name_list" item-value="id" persistent-hint  :error="errorMsg.ett_templatename?true:false" :error-messages="errorMsg.ett_templatename?'Required':''"></v-select>
                                            </v-col> -->

                                                <!-- <v-row justify="space-around" align="center">
                                                    <v-col style="width: 290px; flex: 0 1 auto;">
                                                        <h2>Start:</h2>
                                                        <v-time-picker use-seconds v-model="editedItem.starttime" :max="editedItem.endtime"></v-time-picker>
                                                    </v-col>
                                                    <v-col style="width: 290px; flex: 0 1 auto;">
                                                        <h2>End:</h2>
                                                        <v-time-picker use-seconds v-model="editedItem.endtime" :min="editedItem.starttime"></v-time-picker>
                                                    </v-col>
                                                </v-row> -->
                                            </v-row>
                                            <v-row dense>
                                                <v-col cols="12">
                                                    <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active?"></v-checkbox>
                                                </v-col>
                                                <v-col>
                                                    <input type="hidden" v-model="editedItem.id" name="id" />
                                                    <!--  <v-hidden v-model="editedItem.id" label="id"></v-hidden> -->
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="button-cancel" text @click="close">Cancel</v-btn>
                                        <v-btn class="button" @click="save">Save</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.isactive="{ item }">
                        <span v-if="item.isactive">
                            <v-icon color="success" class="mr-2">mdi-check-circle-outline</v-icon>
                        </span>
                        <span v-else>
                            <v-icon color="error" class="mr-2">mdi-close-circle-outline</v-icon>
                        </span>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <div>
                            <v-avatar style="" size="33" class="edit-avatar">
                                <v-icon color="rgb(1, 127, 152)" size="18" @click="editItem(item)">edit</v-icon>
                            </v-avatar>
                        </div>
                        <!-- <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon> -->
                    </template>
                </v-data-table>
            </template>
        </v-card>
        <v-dialog v-model="dialog_send" hide-overlay persistent width="300">
            <v-card color="#4CAF50" dark>
                <v-card-text>
                    "Please wait..." while file is Importing?
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import axios from "axios";
    import datetime from "vuejs-datetimepicker";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        components: {
            datetime,
        },
        data: () => ({
            org: "",
            errorMsg: {
                ett_programtype: false,
                ett_course: false,
                ett_program: false,
                ett_year: false,
                ett_examslot: false,
                ett_exam: false,
                ett_examstatus: false,
                // ett_templatename: false,
            },
            output_load:false,
            dialog_send: false,
            selected_ay:'',
            selected_sem:'',
            file: null,
            loading3: false,
            tempname: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: "",
            load: false,
            dialog: false,
            ay_list: null,
            sem_list: null,
            exam_list:null,
            examtimetable_list: null,
            selected_exam:'',
            exam_program_type_list: null,
            exam_course_list: null,
            exam_program_list: null,
            exam_year_list: null,
            exam_slot_list: null,
            examlist: null,
            exam_status_list: null,
            exam_template_name_list: null,
             export_table_headers:{
                'Sr.No.': 'srno',
                'Exam': 'ett_exam',
                'Exam Date': 'ett_examdate',
                'Exam Slot.': 'ett_examslot',
                'Course': 'ett_course',
                'Program Type': 'ett_programtype',
                'Program': 'ett_program',
                'Year': 'ett_year',
                'Exam Status' : 'ett_examstatus',
                'Isactive' : 'isactive'
            },
            headers: [
                {
                    text: "Sr.NO",
                    value: "srno",
                },
                {
                    text: "Exam",
                    value: "ett_exam",
                },
                {
                    text: "Exam Date",
                    value: "ett_examdate",
                },
                {
                    text: "Exam Slot",
                    value: "ett_examslot",
                },
                {
                    text: "Course",
                    value: "ett_course",
                },
                {
                    text: "Program Type",
                    value: "ett_programtype",
                },
                {
                    text: "Program",
                    value: "ett_program",
                },
                {
                    text: "Year",
                    value: "ett_year",
                },
                // {
                //   text:"Pattern",
                //   value :"ett_syllabus_pattern"
                // },
                {
                    text: "Exam Status.",
                    value: "ett_examstatus",
                },
                // { text: "Template Name.", value: "ett_templatename" },
                {
                    text: "Active",
                    value: "isactive",
                },
                {
                    text: "Actions",
                    value: "actions",
                    sortable: false,
                },
                /* { text: "Sr.No.", value: "id" },
             { text: "Exam ", value: "ett_exam" },
             { text: "Program Type", value: "ett_programtype" },
             { text: "Program", value: "ett_program" },
             { text: "Course Name", value: "ett_course" },
             { text: "Year.", value: "ett_year" },
             { text: "Exam Slot", value: "ett_examslot" },
             { text: "Exam Status.", value: "ett_examstatus" },
             { text: "Template Name.", value: "ett_templatename" },
             { text: "Exam Date.", value: "ett_examdate" },
             { text: "Actions", value: "actions", sortable: false },
              {
                 text: "Active",
                 value: "isactive"
             },*/
            ],

            editedIndex: -1,
            editedItem: {
                id: "",
                ett_programtype: "",
                ett_course: "",
                ett_program: "",
                ett_year: "",
                ett_examslot: "",
                ett_exam: "",
                ett_examdate: "",
                // starttime: "",
                // endtime: "",
                isactive: true,
                ett_examstatus: "",
                ett_course_id:"",
                // ett_templatename:"",
            },
            defaultItem: {
                id: "",
                ett_programtype: "",
                ett_course: "",
                ett_program: "",
                ett_year: "",
                ett_examslot: "",
                ett_exam: "",
                ett_examdate: "",
                starttime: "",
                endtime: "",
                isactive: true,
                ett_examstatus: "",
                //  ett_templatename:"",
            },
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New Exam Time Table" : "Edit Exam Time Table";
            },
        },

        watch: {
            dialog(val) {
                val || this.close();
            },
        },
        mounted() {
            /* axios
             .post("/ImportExamTT/importExamTimeTableHome")
             .then(res => {
                 if (res.data.msg == "200") {
                     this.examtimetable_list = res.data.examtimetable_list;
                     this.exam_program_type_list = res.data.exam_program_type_list;
                     this.exam_course_list = res.data.exam_course_list;
                     this.exam_program_list = res.data.exam_program_list;
                     this.exam_year_list = res.data.exam_year_list;
                     this.exam_slot_list = res.data.exam_slot_list;
                     this.examlist = res.data.examlist;
                   //  this.exam_template_name_list = res.data.exam_template_name_list;
                     this.exam_status_list = res.data.exam_status_list;
                     this.load = true;
                 } else {}
             })
             .catch(error => {
                 window.console.log(error);
             });*/
            this.loadData();
        },

        methods: {
            loadData() {
                axios
                    .post("/ImportExamTT/importExamTimeTableHome")
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.examtimetable_list = res.data.examtimetable_list;
                            this.ay_list = res.data.ay_list;
                            this.sem_list = res.data.sem_list;
                            this.exam_program_type_list = res.data.exam_program_type_list;
                            this.exam_course_list = res.data.exam_course_list;
                            this.exam_program_list = res.data.exam_program_list;
                            this.exam_year_list = res.data.exam_year_list;
                            this.exam_slot_list = res.data.exam_slot_list;
                            this.examlist = res.data.examlist;
                            this.org = res.data.org;
                            //  this.exam_template_name_list = res.data.exam_template_name_list;
                            this.exam_status_list = res.data.exam_status_list;

                            this.load = true;
                        } else {
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            },
            findexam() {
                const data = {
                    selected_ay: this.selected_ay,
                    selected_sem: this.selected_sem,
                };
                axios
                    .post("/ImportExamTT/fetchExamData", data)
                    .then(res => {
                        window.console.log(res);
                        if (res.data.msg == "200") {
                            this.exam_list = res.data.exam_list;
                                //this.orglist.name=res.data.org.name
                            document.getElementById("subdiv").style.display = "block";
                            //this.domainpath=res.data.domainpath
                        } else {
                            this.message = res.data.msg;
                        }
                    })
                    .catch(error => {
                        window.console.log("error:" + error);
                    })
                    .finally(() => (this.fetch_org_load = false));
            },
            findexamtimetable() {
                const data = {
                    selected_ay: this.selected_ay,
                    selected_sem: this.selected_sem,
                    selected_exam: this.selected_exam
                };
                axios
                    .post("/ImportExamTT/fetchAllExamData", data)
                    .then(res => {
                        window.console.log(res);
                        if (res.data.msg == "200") {
                            this.examtimetable_list = res.data.examtimetable_list;
                                //this.orglist.name=res.data.org.name
                        } else {
                            this.message = res.data.msg;
                        }
                    })
                    .catch(error => {
                        window.console.log("error:" + error);
                    })
                    .finally(() => (this.fetch_org_load = false));
            },


            initializeErrorMsgFalse() {
                this.errorMsg.ett_programtype = false;
                this.errorMsg.ett_course = false;
                this.errorMsg.ett_program = false;
                this.year = false;
                this.ett_examslot = false;
                this.ett_exam = false;
                // this.ett_templatename = false;
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            editItem(item) {
                this.editedIndex = this.examtimetable_list.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },

            close() {
                this.dialog = false;
                this.output_load = false;
                this.dialog_send = false;
                this.initializeErrorMsgFalse();
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
            },
            submitFile() {
                if (this.file == null) {
                    this.showSnackbar("#b71c1c", "Please select the file!");
                    //alert("Please select the file!");
                } else {
                    this.output_load = true;
                    let formData = new FormData();
                    formData.append("file", this.file);
                    this.dialog_send = true;
                    axios
                        .post("ImportExamTT/import_examtt", formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        })
                        .then((res) => {
                            if (res.data.msg == "200") {
                                this.examtt_list = res.data.examtt_list;
                                this.load = true;
                                if (res.data.datamsg == null) {
                                    this.output_load = false;
                                    this.dialog_send = false;
                                    this.loadData();
                                    this.showSnackbar("#4CAF50", "Subject Import Successfully !!");
                                } else {
                                    this.output_load = false;
                                    this.dialog_send = false;
                                    this.showSnackbar("#b71c1c", res.data.datamsg);
                                }
                            } else {
                                this.output_load = false;
                                this.dialog_send = false;
                                this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            }
                        })
                        .catch(function () {
                            console.log("FAILURE!!");
                        })
                        .finally(() => {
                            this.output_load = false;
                        });
                    //     }
                }
            }, //end of the fuction

            save() {
                if (this.editedIndex > -1) {
                    if (this.isValidated()) {
                        //  console.log("edit.." + this.editedItem);

                        axios
                            .post("/ImportExamTT/editExamtt", this.editedItem)
                            .then((res) => {
                                if (res.data.msg == "200") {
                                    this.loadData();
                                    //Object.assign(this.examtimetable_list[this.editedIndex], this.editedItem);
                                    this.showSnackbar("#4caf50", "Exam Time Table Updated Successfully..."); // show snackbar on success
                                } else {
                                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                                }
                            })
                            .catch((error) => {
                                window.console.log(error);
                            });

                        this.close();
                    }
                } else {
                    if (this.isValidated()) {
                        axios
                            .post("/ImportExamTT/saveExamtt", this.editedItem)
                            .then((res) => {
                                if (res.data.status.code == "SUCCESS") {
                                    this.loadData();
                                    this.showSnackbar("#4caf50", " Exam Time Table Added Successfully..."); // show snackbar on success
                                    
                                } else if (res.data.status.code == "NA") {
                                    this.showSnackbar("#b71c1c", " Exam Time Table Already Present!!!"); // show snackbar on error
                                } else {
                                    this.showSnackbar("#b71c1c", "Something Went Wrong....!!!"); // show snackbar on error
                                }
                            })
                            .catch((error) => {
                                window.console.log(error);
                            });

                        this.close();
                    }
                }
            }, // end of save()

            isValidated() {
                if (this.editedItem.ett_examslot && this.editedItem.ett_exam) {
                    //&& this.editedItem.ett_templatename) {
                    return true;
                } else {
                    // if (!this.editedItem.ett_programtype) {
                    //     this.errorMsg.ett_programtype = true;
                    //     return false;
                    // }
                    // if (!this.editedItem.ett_program) {
                    //     this.errorMsg.ett_program = true;
                    //     return false;
                    // }
                    // if (!this.editedItem.ett_year) {
                    //     this.errorMsg.ett_year = true;
                    //     return false;
                    // }
                    if (!this.editedItem.ett_examslot) {
                        this.errorMsg.ett_examslot = true;
                        return false;
                    }
                    if (!this.editedItem.ett_exam) {
                        this.errorMsg.ett_examslot = true;
                        return false;
                    }
                    // if (!this.editedItem.ett_examstatus) {
                    //     this.errorMsg.ett_examstatus = true;
                    //     return false;
                    // }
                    // if (!this.editedItem.ett_templatename) {
                    //       this.errorMsg.ett_templatename = true;
                    // return false;
                    //}
                }
            },
        },
    };
</script>

<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }

    .v-icon-size {
        font-size: 20px;
    }

    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }

    .edit-avatar:hover {
        background-color: #b0bec5;
    }

    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }

    .edit-v-icon:hover {
        color: white;
    }

    .downbtn {
        float: right;
    }

    .datetime {
        padding-left: 20px;
        padding-right: 20px;
        margin: 20px;
    }
    .box {
        background-color: #add8e630;
        margin: 8px !important;
        padding: 8px;
    }
    .flex {
        display: flex;
        justify-content: space-between;
    }
    @media only screen and (max-width: 600px) {
        .flex {
            display: block;
        }
    }
</style>
